// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"audit-trail_contentInnerContainer__S-3eV"};